export default {
    get() {
        var storage = window.localStorage, name = "app-device-finger", finger = storage.getItem(name);
        if (!finger) {
            finger = Math.random().toString(36).substr(2);
            storage.setItem(name, finger);
        }
        return finger;
    }
}